const stateLabel = () => {
    switch (window.Shopify.country) {
        case `AU`:
            return `State`
        case `CA`:
            return `Province`
        case `NZ`:
            return `Region`
    }
}
const stateOptions = () => {
    switch (window.Shopify.country) {
        case `AU`:
            return [
                `Australian Capital Territory`,
                `New South Wales`,
                `Northern Territory`,
                `Queensland`,
                `South Australia`,
                `Tasmania`,
                `Victoria`,
                `Western Australia`
            ]
        case `CA`:
            return [
                `Alberta`,
                `British Columbia`,
                `Manitoba`,
                `New Brunswick`,
                `Newfoundland and Labrador`,
                `Nova Scotia`,
                `Northwest Territories`,
                `Nunavut`,
                `Ontario`,
                `Prince Edward Island`,
                `Quebec`,
                `Saskatchewan`,
                `Yukon Territories`,
            ]
        case `NZ`:
            return [
                `Northland`,
                `Auckland`,
                `Waikato`,
                `Bay of Plenty`,
                `Gisborne`,
                `Hawkes Bay`,
                `Taranaki`,
                `Whanganui-Manawatu`,
                `Wellington`,
                `Marlborough`,
                `Nelson`,
                `West Coast`,
                `Canterbury`,
                `Otago`,
                `Southland`,
            ]
    }
}
export {stateLabel, stateOptions}
